// Errors
export const GET_ERRORS = "GET_ERRORS";
export const NO_ERRORS = "NO_ERRORS";

// Users
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const EDIT_USER = "EDIT_USER";

// Children
export const CHILD_ADDED = "ADD_CHILD";
export const GET_CHILDREN = "GET_CHILDREN";
export const CHILD_REMOVED = "CHILD_REMOVED";

// Feeds
export const FEED_ADDED = "FEED_ADDED";
export const GET_FEEDS = "GET_FEEDS";
export const FEED_DELETED = "FEED_DELETED";
export const FEED_UPDATED = "FEED_UPDATED";

// Poops
export const POOP_ADDED = "POOP_ADDED";
export const GET_POOPS = "GET_POOPS";
export const POOP_DELETED = "POOP_DELETED";
export const POOP_UPDATED = "POOP_UPDATED";

// Sleeps
export const SLEEP_ADDED = "SLEEP_ADDED";
export const GET_SLEEP = "GET_SLEEP";
export const SLEEP_DELETED = "SLEEP_DELETED";
export const SLEEP_UPDATED = "SLEEP_UPDATED";

// Medication
export const MEDICATION_ADDED = "MEDICATION_ADDED";
export const GET_MEDICATION = "GET_MEDICATION";
export const MEDICATION_DELETED = "MEDICATION_DELETED";
export const MEDICATION_UPDATED = "MEDICATION_UPDATED";
